import React from "react";
const EmailToLinkButton = ({ mailto, label }) => {
    return (
        <>
        <a href={mailto}> {label}</a>
        </>       
    );
};
export default EmailToLinkButton;